import { createContext } from 'react'

export type DevtoolsContextName =
  | 'defaultContext'
  | 'cachedNotesContext'
  | 'googleCalendarDataContext'

export type DevtoolsState = {
  activeContext: DevtoolsContextName | undefined
}

export type DevtoolsContextType = {
  devtoolsState: DevtoolsState
  toggleDevtools: (context: DevtoolsContextName) => void
}

export const DevtoolsContext = createContext<DevtoolsContextType | undefined>(
  undefined
)
